
import { UserSubscriptionTransaction } from "@/domain/entities/UserSubscriptionTransaction";
import { PropType } from "vue";
import UserSubscriptionTransactionItem from "./UserSubscriptionTransactionItem.vue";
import UserSubscriptionHistoryPresentationMappers from "@/presentation/mappers/UserSubscriptionTransactionPresentationMappers";
export default {
  name: "UserSubscriptionHistory",
  props: {
    transactions: {
      type: Array as PropType<UserSubscriptionTransaction[]>,
      required: true,
    },
    loading: { type: Boolean },
  },
  components: {
    UserSubscriptionTransactionItem,
  },
  data() {
    return {
      columns: [
        {
          name: "Data",
          sortName: null,
          order: null,
        },
        {
          name: "Plano",
          sortName: null,
          order: null,
        },
        {
          name: "Gateway",
          sortName: null,
          order: null,
        },
        {
          name: "Tipo",
          sortName: null,
          order: null,
        },
        {
          name: "Valor",
          sortName: null,
          order: null,
        },
        {
          name: "Status",
          sortName: null,
          order: null,
        },
      ],
      UserSubscriptionHistoryPresentationMappers,
    };
  },
};
